import React, { useEffect, useState, createElement } from 'react';
import './index.css';
const META_PIXEL_ID = '2002099947325430';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Después de completar el pago recibís un link de descarga inmediata por email. Podés descargar los PDFs en tu celular, tablet o computadora y leerlos sin conexión.'
}, {
  q: '¿Funciona para cualquier tipo de dolor de espalda?',
  a: 'El método está orientado a los dolores más comunes: lumbalgia, contracturas, dolor cervical y torácico por mala postura o tensión muscular. Si tu caso requiere intervención médica urgente, el Tomo 1 te ayudará a identificarlo.'
}, {
  q: '¿Necesito tener experiencia en ejercicio o kinesiología?',
  a: 'No. El contenido está escrito para personas sin conocimientos previos. Cada técnica incluye descripción paso a paso y ilustraciones. Si podés leer este texto, podés aplicar el método.'
}, {
  q: '¿Cuánto tiempo por día necesito dedicarle?',
  a: 'Las rutinas principales van de 10 a 20 minutos diarios. El Bono #1 tiene una secuencia de solo 5 minutos para cuando el tiempo es escaso. Podés ajustar el ritmo a tu vida.'
}, {
  q: '¿Qué pasa si el método no me funciona?',
  a: 'Tenés 7 días de garantía completa. Si aplicás el método y no notás mejora, te devolvemos el 100% del dinero sin ningún tipo de problema. El riesgo es nuestro.'
}, {
  q: '¿En qué formato están los archivos?',
  a: 'Todos los materiales son PDF de alta calidad. Compatibles con cualquier dispositivo — iPhone, Android, Windows, Mac.'
}];
export default function App() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (w.fbq) {
      w.fbq('track', 'PageView');
      return;
    }
    /* Meta Pixel Code — initialize fbq stub */
    const n: any = w.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    /* Inject the Facebook events script safely */
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      ;
      (document.head || document.documentElement).appendChild(script);
    }
    w.fbq('init', META_PIXEL_ID);
    w.fbq('track', 'PageView');
  }, []);
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      <div data-id="element-0" data-mp="2xtlnt8e6uigy">
        {/* ANNOUNCEMENT */}

        {/* NAV */}

        {/* HERO */}
        <section className="hero text-[14px]" data-id="element-1" data-mp="2suqzjqxgc1pg">
          <div className="hero-badge text-[14px] pl-[14px] pr-[14px] gap-[6px]" data-id="element-2" data-mp="2stzcj4hx7cas">
            ✦ Método respaldado por terapeutas y kinesiólogos
          </div>
          <h1 className="text-[#F97316] font-[600] text-[24px]" data-id="element-3" data-mp="1d59linbc7m0d">
            Decile adiós al dolor de espalda para siempre
          </h1>
          <img src="https://cdn.magicpatterns.com/uploads/xrSyG3vqFTR26i9XibU28n/mockup2.png" alt="Profesional de la salud sosteniendo el Mega Pack Espalda Sin Dolor con sello de garantía de 7 días" className="hero-mockup" data-id="element-4" data-mp="ydquzvkuq92r" />
          <a href="#pricing" className="btn-main text-[18px] font-[900]" style={{
          marginTop: '20px'
        }} onClick={scrollToPricing} data-id="element-5" data-mp="1w2tzgzckd067">
            🎯 Quiero el Mega Pack + Poster Imprimible
          </a>
          <p className="subtitle text-[24px]" data-id="element-6" data-mp="6nmfaa81ea7v">
            El sistema completo de 6 Tomos + 6 Bonos exclusivos + Poster
            Imprimible de regalo para que recuperes tu vida sin dolor, desde
            casa y a tu ritmo.
          </p>
          <div className="hero-cta-group" data-id="element-7" data-mp="qyyq3mkhxomp">
            <div className="hero-guarantee" data-id="element-8" data-mp="m65nb48l8qd9">
              <span className="icon" data-id="element-9" data-mp="m4cdjg2ohq11">✅</span>
              Garantía de 7 días — si no te ayuda, te devolvemos el dinero
            </div>
          </div>
          <div className="hero-visual" data-id="element-10" data-mp="c90yewncygsr">
            {[['01', 'Entendé tu Dolor de Espalda'], ['02', 'Ejercicios y Terapias Sin Dolor'], ['03', 'Postura, Hábitos y Prevención'], ['04', 'Movilidad y Flexibilidad Funcional'], ['05', 'Manejo del Dolor Crónico y la Mente'], ['06', 'Rutinas por Zona y Casos Especiales']].map(([num, title]) => <div className="hero-book" key={num} data-id="element-11" data-mp="vybbe2vpynn6">
                <div className="book-num" data-id="element-12" data-mp="3kob38cimu048">{num}</div>
                <div className="book-label" data-id="element-13" data-mp="3klq07k6lle4w">Tomo</div>
                <div className="book-title" data-id="element-14" data-mp="3glegc9m27huh">{title}</div>
              </div>)}
          </div>
        </section>

        {/* TRUST BAR */}
        <div className="trust-bar" data-id="element-15" data-mp="1w2lv33r80jcy">
          {[['📥', 'Descarga inmediata'], ['📱', 'Compatible con celular, tablet y PC'], ['🔒', 'Pago 100% seguro'], ['⭐', '+500 personas sin dolor']].map(([icon, text]) => <div className="trust-item" key={text} data-id="element-16" data-mp="29x4pot0xaikp">
              <span data-id="element-17" data-mp="2evg1386v9151">{icon}</span> {text}
            </div>)}
        </div>

        {/* PROBLEM */}
        <section className="section problem-section" data-id="element-18" data-mp="2jt83iw5505nh">
          <div className="section-inner" data-id="element-19" data-mp="2jw3x689yc864">
            <div className="section-tag" data-id="element-20" data-mp="2nvcshhkn4e3s">El Problema</div>
            <h2 className="section-title" data-id="element-21" data-mp="2ntrzhwdz5381">
              ¿Te identificás con alguna de estas situaciones?
            </h2>
            <p className="section-desc" data-id="element-22" data-mp="thtphs7uc3b3">
              El dolor de espalda destruye tu calidad de vida poco a poco. Estos
              son los errores más comunes que lo mantienen activo:
            </p>
            <div className="pain-grid" data-id="element-23" data-mp="21r2a8101edoj">
              {[['😖', 'Te despertás con dolor todas las mañanas', 'Y el día empieza mal antes de que siquiera te pares de la cama. Nada de lo que probaste funciona de forma duradera.'], ['💊', 'Dependés de pastillas para funcionar', 'Los analgésicos son un parche temporal. El dolor vuelve y cada vez necesitás más medicación para el mismo alivio.'], ['🪑', 'No podés estar sentado más de 30 minutos', 'El trabajo se vuelve una tortura. La mala postura empeoró todo y nadie te enseñó cómo realmente corregirla.'], ['😔', 'Dejaste de hacer cosas que antes amabas', 'Deporte, salidas, jugar con tus hijos. El dolor te fue robando actividades sin que te des cuenta.']].map(([icon, title, text]) => <div className="pain-card" key={title as string} data-id="element-24" data-mp="3n2zk1cbjq8af">
                  <div className="pain-icon" data-id="element-25" data-mp="385gva9yvbv2z">{icon}</div>
                  <h3 data-id="element-26" data-mp="384xcys5b34of">{title}</h3>
                  <p data-id="element-27" data-mp="387tesrk9ydi5">{text}</p>
                </div>)}
            </div>
          </div>
        </section>

        {/* SOLUTION */}
        <section className="section solution-section" data-id="element-28" data-mp="2zc3uklukbp6c">
          <div className="section-inner" data-id="element-29" data-mp="2zbanfjroyxno">
            <div className="section-tag" data-id="element-30" data-mp="344wyx8m4cvhw">La Solución</div>
            <h2 className="section-title" data-id="element-31" data-mp="2pez78iozdnny">
              El sistema que te devuelve el control de tu cuerpo
            </h2>
            <p className="section-desc" data-id="element-32" data-mp="2udiqucg3qnd5">
              El Mega Pack Espalda Sin Dolor combina técnicas de kinesiología,
              biomecánica y neurociencia del dolor en un formato simple y
              aplicable desde el primer día.
            </p>
            <div className="solution-box" data-id="element-33" data-mp="2khyyg00qy6t5">
              <div className="solution-text" data-id="element-34" data-mp="30vwznjlm5bfg">
                <h3 data-id="element-35" data-mp="30ulxtpbqadqz">¿Por qué este método funciona?</h3>
                <ul className="solution-list" data-id="element-36" data-mp="2vw0x7oskds20">
                  {['Ataca la causa raíz, no solo el síntoma', 'Técnicas validadas por especialistas en columna', 'Aplicable sin equipamiento ni gimnasio', 'Rutinas de 10–20 minutos por día', 'Resultados visibles en las primeras 2 semanas', 'Lenguaje claro, sin términos médicos confusos'].map(item => <li key={item} data-id="element-37" data-mp="285wvjmyxs2dn">
                      <span className="check" data-id="element-38" data-mp="287819sbxzk7e">✅</span> {item}
                    </li>)}
                </ul>
              </div>
              <div className="solution-stats" data-id="element-39" data-mp="1y8abyn6ozmnc">
                {[['87%', 'De las personas reportan alivio en las primeras 2 semanas'], ['+500', 'Personas ya recuperaron su calidad de vida con este método'], ['30 días', 'Es todo lo que necesitás para ver cambios reales']].map(([num, label]) => <div className="stat-box" key={num as string} data-id="element-40" data-mp="nnw4bni1qtka">
                    <div className="stat-num" data-id="element-41" data-mp="3m72r0o22q3n6">{num}</div>
                    <div className="stat-label" data-id="element-42" data-mp="3m4gjgof6no4y">{label}</div>
                  </div>)}
              </div>
            </div>
          </div>
        </section>

        {/* TOMOS */}
        <section className="section inside-section" data-id="element-43" data-mp="3w2e8vf8s3qz5">
          <div className="section-inner" data-id="element-44" data-mp="4quvtspaabbl">
            <div className="section-tag" data-id="element-45" data-mp="4rw63uyh6ts9">Qué incluye</div>
            <h2 className="section-title" data-id="element-46" data-mp="33es5o83gqoct">
              Todo lo que necesitás en un solo pack
            </h2>
            <p className="section-desc" data-id="element-47" data-mp="38dbqg56blu3l">
              6 guías completas en PDF, diseñadas para leer en orden o consultar
              por tema. Sin relleno, sin paja — pura información accionable.
            </p>
            <div className="tomos-grid" data-id="element-48" data-mp="2k4diga6jax2q">
              {[{
              num: 'Tomo 1',
              title: 'Entendé tu Dolor de Espalda',
              desc: 'El punto de partida: entender qué está pasando en tu cuerpo para poder resolverlo de raíz.',
              topics: ['Anatomía de la columna en lenguaje simple', 'Las 7 causas más frecuentes del dolor crónico', 'Por qué el reposo empeora la situación', 'Cómo identificar el origen exacto de tu dolor', 'El rol del sistema nervioso en el dolor crónico']
            }, {
              num: 'Tomo 2',
              title: 'Ejercicios y Terapias Sin Dolor',
              desc: 'El corazón del método: rutinas específicas y técnicas de alivio para aplicar desde hoy.',
              topics: ['Rutina de movilización matutina (10 min)', 'Técnicas de liberación muscular en casa', 'Ejercicios de estabilización de columna', 'Cómo respirar para reducir la tensión lumbar', 'Protocolo de urgencia para el dolor agudo']
            }, {
              num: 'Tomo 3',
              title: 'Postura, Hábitos y Prevención',
              desc: 'El capítulo que la mayoría ignora: cómo evitar que el dolor vuelva a instalarse en tu vida.',
              topics: ['Corrección postural para trabajo y descanso', 'Cómo dormir para regenerar la columna', 'Alimentación antiinflamatoria para la espalda', 'Hábitos diarios que destruyen tu postura', 'Plan de mantenimiento a largo plazo']
            }, {
              num: 'Tomo 4',
              title: 'Movilidad y Flexibilidad Funcional',
              desc: 'Recuperá el rango de movimiento que perdiste y devolvele elasticidad a tu espalda sin forzarla.',
              topics: ['Tests caseros para medir tu movilidad real', 'Secuencia de estiramientos progresivos', 'Movilidad de cadera para descargar la zona lumbar', 'Cómo destrabar la zona dorsal y cervical', 'Rutina de flexibilidad de 8 minutos']
            }, {
              num: 'Tomo 5',
              title: 'Manejo del Dolor Crónico y la Mente',
              desc: 'El componente que casi nadie trabaja: cómo el estrés y la mente amplifican o calman el dolor.',
              topics: ['La conexión entre estrés y tensión muscular', 'Técnicas de respiración para el dolor crónico', 'Cómo romper el ciclo dolor-miedo-rigidez', 'Mini-meditaciones guiadas para el alivio', 'Hábitos mentales que reducen la percepción del dolor']
            }, {
              num: 'Tomo 6',
              title: 'Rutinas por Zona y Casos Especiales',
              desc: 'Protocolos específicos según dónde te duele y según tu situación particular.',
              topics: ['Rutina específica para dolor lumbar', 'Rutina específica para dolor cervical', 'Qué hacer durante el embarazo y el postparto', 'Adaptaciones para adultos mayores', 'Plan de retorno seguro a la actividad física']
            }].map(t => <div className="tomo-card" key={t.num} data-id="element-49" data-mp="hmtf5etyb6c6">
                  <div className="tomo-header" data-id="element-50" data-mp="hoe9b3ccsn9i">
                    <div className="tomo-num" data-id="element-51" data-mp="mlmtf9h2b1de">{t.num}</div>
                    <div className="tomo-title" data-id="element-52" data-mp="mm6citig7vt0">{t.title}</div>
                  </div>
                  <div className="tomo-body" data-id="element-53" data-mp="qmqau0erd5gq">
                    <p data-id="element-54" data-mp="vml0y1qplr0q">{t.desc}</p>
                    <ul className="tomo-topics" data-id="element-55" data-mp="vnnp41wndfcy">
                      {t.topics.map(tp => <li key={tp} data-id="element-56" data-mp="10kmi2h4krg9k">{tp}</li>)}
                    </ul>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* BONUSES */}
        <section className="section bonus-section" data-id="element-57" data-mp="1ac0lgzznd07z">
          <div className="section-inner" data-id="element-58" data-mp="1edlwsgwj96g2">
            <div className="section-tag" style={{
            background: '#fff7ed',
            color: '#c2410c'
          }} data-id="element-59" data-mp="1eckmienccnze">
              Bonos Exclusivos
            </div>
            <h2 className="section-title" data-id="element-60" data-mp="1o8xg7civz1u5">
              6 bonos para acelerar tus resultados
            </h2>
            <p className="section-desc" data-id="element-61" data-mp="1tgdkjfgqynzg">
              Incluidos sin costo adicional. Valorados en más de $15.000 ARS.
            </p>
            <div className="bonuses-grid" data-id="element-62" data-mp="1oi29x2imo9g6">
              {[{
              tag: 'BONO #1',
              icon: '⚡',
              title: 'Rutina de Alivio Inmediato en 5 Minutos',
              desc: 'La secuencia exacta de 4 movimientos para cortar el dolor en el momento. Ideal para crisis agudas o mañanas difíciles.'
            }, {
              tag: 'BONO #2',
              icon: '🖥️',
              title: 'Guía de Ergonomía Para Tu Hogar y Trabajo',
              desc: 'Cómo configurar tu silla, escritorio, monitor y cama para que tu columna descanse incluso mientras trabajás.'
            }, {
              tag: 'BONO #3',
              icon: '🥗',
              title: 'Plan de Alimentación Antiinflamatoria',
              desc: '7 días de menú diseñado para reducir la inflamación sistémica que alimenta el dolor crónico de espalda.'
            }, {
              tag: 'BONO #4',
              icon: '🎧',
              title: 'Audio-Guías de Relajación Muscular',
              desc: 'Sesiones de audio para relajar la musculatura de la espalda y bajar la tensión al final del día.'
            }, {
              tag: 'BONO #5',
              icon: '📋',
              title: 'Checklist de Progreso Imprimible',
              desc: 'Una planilla simple para registrar tu rutina diaria y ver tu evolución semana a semana.'
            }, {
              tag: 'BONO #6',
              icon: '💬',
              title: 'Acceso al Grupo de Soporte',
              desc: 'Sumate a la comunidad para resolver dudas, compartir avances y mantenerte motivado.'
            }].map(b => <div className="bonus-card" key={b.tag} data-id="element-63" data-mp="3kc226cn88pws">
                  <div className="bonus-tag" data-id="element-64" data-mp="3fgmr1sglt842">{b.tag}</div>
                  <div className="bonus-icon" data-id="element-65" data-mp="3u3y1ts4yoo34">{b.icon}</div>
                  <h3 data-id="element-66" data-mp="3u5ix5jz3ob21">{b.title}</h3>
                  <p data-id="element-67" data-mp="3pdhlo09raod2">{b.desc}</p>
                  <div className="bonus-value" data-id="element-68" data-mp="3pcgc608e29xg">Valor: $5.000 ARS — GRATIS</div>
                </div>)}
            </div>
          </div>
        </section>

        {/* TESTIMONIALS */}
        <section className="section testimonials-section" data-id="element-69" data-mp="2yomcuelfs7r">
          <div className="section-inner" data-id="element-70" data-mp="309gwk0wrb5m">
            <div className="section-tag" data-id="element-71" data-mp="gwmuvj68gufc">Testimonios</div>
            <h2 className="section-title" data-id="element-72" data-mp="bylcz1kjn15g">
              Personas reales, resultados reales
            </h2>
            <div className="testimonials-grid" data-id="element-73" data-mp="2ioswshhcydgc">
              {[{
              init: 'M',
              name: 'Marcelo R.',
              meta: 'Administrativo · Buenos Aires',
              quote: '"Llevaba 3 años con dolor lumbar constante. A los 15 días de empezar el Tomo 2 noté una diferencia enorme. Ahora puedo estar sentado en el trabajo sin ese ardor que me mataba."'
            }, {
              init: 'L',
              name: 'Laura V.',
              meta: 'Docente · Córdoba',
              quote: '"Lo que más me gustó es que explica el POR QUÉ de todo, no solo dice \'hacé esto\'. Entender qué estaba pasando en mi columna me cambió la cabeza. Recomendadísimo."'
            }, {
              init: 'G',
              name: 'Gabriel T.',
              meta: 'Freelancer · Rosario',
              quote: '"Pasé por el médico, el kinesiólogo y mil pastillas. Este pack me dio más herramientas concretas que cualquier consulta pagada. La guía de ergonomía sola valió todo."'
            }].map(t => <div className="testimonial-card" key={t.name} data-id="element-74" data-mp="nnimgn9zn7ea">
                  <div className="stars" data-id="element-75" data-mp="np3jqknot4fu">★★★★★</div>
                  <p className="quote" data-id="element-76" data-mp="ioyxsf40fhi8">{t.quote}</p>
                  <div className="testimonial-author" data-id="element-77" data-mp="iqa34jd3sxbg">
                    <div className="author-avatar" data-id="element-78" data-mp="dvwdyyp1bmf8">{t.init}</div>
                    <div className="author-info" data-id="element-79" data-mp="8ye67bmr7d8t">
                      <div className="name" data-id="element-80" data-mp="8xujziq2m2oz">{t.name}</div>
                      <div className="meta" data-id="element-81" data-mp="3zjcvfr5u6ag">{t.meta}</div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
        </section>

        {/* PRICING */}
        <section className="section pricing-section" id="pricing" data-id="element-82" data-mp="3r4seatyccsza">
          <div className="section-inner" style={{
          textAlign: 'center'
        }} data-id="element-83" data-mp="3m4wbgy1dr7lb">
            <div className="section-tag" data-id="element-84" data-mp="1pb1kkdsae544">Precio</div>
            <h2 className="section-title" data-id="element-85" data-mp="1kd9p59sfo0v6">Acceso completo hoy, sin cuotas</h2>
            <p className="section-desc" style={{
            margin: '0 auto'
          }} data-id="element-86" data-mp="1kb6q609ayxeb">
              Una sola inversión para tener el método completo: los 6 tomos, los
              6 bonos y el Poster Imprimible de regalo, descargados en tu
              dispositivo para siempre.
            </p>
            <div className="pricing-box" data-id="element-87" data-mp="1xheqtqvyz6i3">
              <div className="best-value" data-id="element-88" data-mp="1xgddffrhe7x7">🔥 PRECIO DE LANZAMIENTO</div>
              <div className="price-original" data-id="element-89" data-mp="1thmhhbyr4wbo">Valor total: $39.990 ARS</div>
              <div className="price-main" data-id="element-90" data-mp="1ohi6g1gm4tsu">
                <span className="price-currency" data-id="element-91" data-mp="1ojunmcejr04u">$</span>24.990
              </div>
              <div className="price-period" data-id="element-92" data-mp="1jj6xdsy56nbo">
                ARS — pago único, acceso de por vida
              </div>
              <ul className="price-includes" data-id="element-93" data-mp="1elono0caw42m">
                <li data-id="element-94" data-mp="3dwy4olt00v3y">
                  <span className="check" data-id="element-95" data-mp="3dveoswb98m2p">✅</span> Tomo 1: Entendé tu Dolor de
                  Espalda
                </li>
                <li data-id="element-96" data-mp="38yekapu1zrdp">
                  <span className="check" data-id="element-97" data-mp="3helu69qjzf9b">✅</span> Tomo 2: Ejercicios y
                  Terapias Sin Dolor
                </li>
                <li data-id="element-98" data-mp="3lffhp2032s1o">
                  <span className="check" data-id="element-99" data-mp="3lewaogbz1o2f">✅</span> Tomo 3: Postura, Hábitos y
                  Prevención
                </li>
                <li data-id="element-100" data-mp="3q90j740vy45m">
                  <span className="check" data-id="element-101" data-mp="3v60ohcpwv2vo">✅</span> Tomo 4: Movilidad y
                  Flexibilidad Funcional
                </li>
                <li data-id="element-102" data-mp="2ygjc6ewfail0">
                  <span className="check" data-id="element-103" data-mp="2yh2qzmqs0qut">✅</span> Tomo 5: Manejo del Dolor
                  Crónico y la Mente
                </li>
                <li data-id="element-104" data-mp="32j67wqw7snnh">
                  <span className="check" data-id="element-105" data-mp="37gpj1hxm8kb7">✅</span> Tomo 6: Rutinas por Zona y
                  Casos Especiales
                </li>
                <li data-id="element-106" data-mp="3cgk8ri5nn3uo">
                  <span className="check" data-id="element-107" data-mp="3cgu31hxqfx66">🎁</span> Bono #1: Rutina de Alivio en
                  5 Minutos
                </li>
                <li data-id="element-108" data-mp="msl4lb5wrboa">
                  <span className="check" data-id="element-109" data-mp="ros9d0mkih4n">🎁</span> Bono #2: Guía de Ergonomía
                </li>
                <li data-id="element-110" data-mp="20mu848cd2re">
                  <span className="check" data-id="element-111" data-mp="204qynn9ho9z">🎁</span> Bono #3: Plan
                  Antiinflamatorio 7 días
                </li>
                <li data-id="element-112" data-mp="3t77hdcv9zqj5">
                  <span className="check" data-id="element-113" data-mp="3t9tlf2iyjnwm">🎁</span> Bono #4: Audio-Guías de
                  Relajación
                </li>
                <li data-id="element-114" data-mp="6zpoquqp3ql4">
                  <span className="check" data-id="element-115" data-mp="71ajakd0f9iz">🎁</span> Bono #5: Checklist de
                  Progreso
                </li>
                <li data-id="element-116" data-mp="3fgkfxcy4rmjd">
                  <span className="check" data-id="element-117" data-mp="3fdycnpi9vt6y">🎁</span> Bono #6: Acceso al Grupo de
                  Soporte
                </li>
                <li data-id="element-118" data-mp="3p5lx36gew9yx">
                  <span className="check" data-id="element-119" data-mp="3p63ysilufge8">🖼️</span> Poster Imprimible de regalo
                </li>
                <li data-id="element-120" data-mp="3kevolkcovr00">
                  <span className="check" data-id="element-121" data-mp="3kdknxtejizd4">🔒</span> Garantía de devolución 7
                  días
                </li>
              </ul>
              <a href="https://espalda-sin-dolores.impultienda.ar/checkout" className="btn-purchase" target="_blank" rel="noopener noreferrer" onClick={() => {
              const w = window as any;
              if (w.fbq) w.fbq('track', 'InitiateCheckout');
            }} data-id="element-122" data-mp="2wn8a61wm68em">
                💳 Quiero el Mega Pack por $24.990
              </a>
              <div className="price-guarantee" data-id="element-123" data-mp="12ae1mk2pscn0">
                🔒 Pago seguro · Descarga inmediata · Sin suscripciones
              </div>
            </div>
          </div>
        </section>

        {/* GUARANTEE */}
        <section className="section guarantee-section" data-id="element-124" data-mp="1uxi4oji8ygw5">
          <div className="section-inner" data-id="element-125" data-mp="1gys6t1nlsd6q">
            <div className="guarantee-box" data-id="element-126" data-mp="1gxpin1ho0oui">
              <div className="guarantee-icon" data-id="element-127" data-mp="1kzkgtx4aum42">🛡️</div>
              <div className="guarantee-text" data-id="element-128" data-mp="1ky0y7zv67yz4">
                <h3 data-id="element-129" data-mp="5jbya6m4erj8">Garantía total de 7 días sin preguntas</h3>
                <p data-id="element-130" data-mp="5l6hnghqubl7">
                  Si aplicás el método durante 7 días y no notás ninguna mejora
                  en tu dolor de espalda, te devolvemos el 100% de tu dinero.
                  Sin formularios, sin burocracia, sin preguntas. Confiamos
                  tanto en este método que el riesgo es completamente nuestro.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="section faq-section" data-id="element-131" data-mp="b3fib6ixyejc">
          <div className="section-inner" data-id="element-132" data-mp="b4qkx30nhg8v">
            <div className="section-tag" data-id="element-133" data-mp="18r7k6dsy23x9">Preguntas frecuentes</div>
            <h2 className="section-title" data-id="element-134" data-mp="18obl2m5d1978">Todo lo que necesitás saber</h2>
            <div className="faq-list" data-id="element-135" data-mp="13s4bmjdr9fkj">
              {faqs.map((faq, i) => <div className={`faq-item${openFaq === i ? ' open' : ''}`} key={i} data-id="element-136" data-mp="yrgq2d8apqxp" data-mpi={i}>
                  <div className="faq-question" onClick={() => setOpenFaq(openFaq === i ? null : i)} data-id="element-137" data-mp="uszdvfa0pq9f">
                    {faq.q} <span className="faq-arrow" data-id="element-138" data-mp="3fgcfttjtlrvx">+</span>
                  </div>
                  <div className="faq-answer" data-id="element-139" data-mp="1uzw7gmfvudkl">{faq.a}</div>
                </div>)}
            </div>
          </div>
        </section>

        {/* FINAL CTA */}
        <section className="final-cta" data-id="element-140" data-mp="23zrj0sdcoal5">
          <h2 data-id="element-141" data-mp="23yzolkvhoiwg">Tu espalda no tiene que doler más</h2>
          <p data-id="element-142" data-mp="28qhrwfkzivkl">
            Hoy es el día en que dejás de aguantar el dolor y empezás a
            recuperar tu vida. El método está listo. Solo falta tu decisión.
          </p>
          <a href="#pricing" className="btn-final" onClick={scrollToPricing} data-id="element-143" data-mp="2drozadj7tsqq">
            🎯 Quiero el Mega Pack Ahora
          </a>
        </section>

        {/* FOOTER */}
        <footer data-id="element-144" data-mp="2mrkdysbzc5vi">
          <div className="footer-logo" data-id="element-145" data-mp="2mr27l2vlsb9v">
            Espalda<span data-id="element-146" data-mp="2rpvn10ugacco">SinDolor</span>
          </div>
          <p style={{
          marginBottom: '12px'
        }} data-id="element-147" data-mp="2rokk138tx8mm">
            © 2026 Mega Pack Espalda Sin Dolor. Todos los derechos reservados.
          </p>
          <div data-id="element-148" data-mp="xbupcjamzve6">
            <a href="#" data-id="element-149" data-mp="xdfa5h75fzyu">Política de Privacidad</a> ·
            <a href="#" data-id="element-150" data-mp="20lgq7zsi1r9u">Términos y Condiciones</a> ·<a href="#" data-id="element-151" data-mp="20mibex38bu5a">Contacto</a>
          </div>
        </footer>

        {/* MOBILE STICKY */}
      </div>
    </>;
}